// extracted by mini-css-extract-plugin
export var linkText = "_pk-0";